import { api } from "../api/http.js";
import type { Bundle } from "../store/types.js";
import type { AchievementsView, CalendarEntry, ClaimableList, DailyView, EventModifier, EventRunView, GrowthView, LootView } from "./types.js";
import type { SiegeView } from "./siege-types.js";

export const eventsApi = {
  list: () => api<{ runs: EventRunView[]; modifiers: EventModifier[] }>("GET", "/api/events", undefined, { fresh: true }), // push-driven refreshes must not settle with a cached reply
  calendar: (days = 14) => api<{ from: number; to: number; runs: CalendarEntry[] }>("GET", `/api/events/calendar?days=${days}`),
  run: (runId: string) => api<EventRunView>("GET", `/api/events/${runId}`),
  claimMilestone: (runId: string, index: number) => api<{ granted: Bundle; run: EventRunView }>("POST", `/api/events/${runId}/milestones/${index}`),
  siege: (runId: string) => api<SiegeView>("POST", `/api/events/${runId}/siege`),
  siegeState: (runId: string) => api<SiegeView | null>("GET", `/api/events/${runId}/siege`),
  siegeNext: (runId: string, revision: number, requestId: string) => api<SiegeView>("POST", `/api/events/${runId}/siege/next`, { revision, requestId }),
  siegeRepair: (runId: string, rowId: string, revision: number, requestId: string) => api<SiegeView>("POST", `/api/events/${runId}/siege/repair/${rowId}`, { revision, requestId }),
  siegeAbandon: (runId: string, revision: number, requestId: string) => api<SiegeView>("POST", `/api/events/${runId}/siege/abandon`, { revision, requestId }),
  trial: (runId: string) => api<{ floor: number; won: boolean; battleId: string; chest: Bundle | null; done: boolean }>("POST", `/api/events/${runId}/trial`),
  relic: (runId: string, index: number) => api<{ won: boolean; battleId: string; holder: string | null; guardLevel: number }>("POST", `/api/events/${runId}/relics/${index}`),
  claimable: () => api<ClaimableList>("GET", "/api/events/claimable"),
  claimAll: () => api<{ claimed: number; skipped: number; loot: LootView }>("POST", "/api/events/claim-all"),
};

export const dailyApi = {
  view: () => api<DailyView>("GET", "/api/daily"),
  claimLogin: () => api<{ granted: Bundle; index: number }>("POST", "/api/daily/login"),
  claimDay28: () => api<{ granted: Bundle }>("POST", "/api/daily/day28"),
  startIntel: (id: string) => api<{ doneAt: number }>("POST", `/api/daily/intel/${id}/start`),
  claimIntel: (id: string) => api<{ granted: Bundle }>("POST", `/api/daily/intel/${id}/claim`),
};

export const growthApi = {
  view: () => api<GrowthView>("GET", "/api/growth"),
  claimMission: (id: string) => api<{ granted: Bundle }>("POST", `/api/growth/missions/${id}`),
  claimChapter: (chapter: number) => api<{ granted: Bundle }>("POST", `/api/growth/chapters/${chapter}`),
};

export const achievementsApi = {
  list: () => api<AchievementsView>("GET", "/api/achievements"),
  claim: (id: string) => api<{ granted: Bundle; title: string | null; frame: string | null }>("POST", `/api/achievements/${id}`),
};
